export default [{channel:'dtc-web',action:{template:'kill-ads',overrideLegacyAppendSlot:true,findSlotsOnLoad:[],slotDefinitions:{}}}]